import React, { Component } from "react";
import PropTypes from "prop-types";

import {
  COLORS,
  COLOR_FOCUS,
  BOX_SIZE,
  COLOR_CORRECT,
  COLOR_EMPTY,
  COLOR_TEXT
} from "../../../../constants";
import Focus from "./Focus";
import CellBackground from "../CellBackground";

export default class Prefilled extends Component {
  static defaultProps = {
    x: 0,
    y: 0,
    cell: {}
  };

  static propTypes = {
    x: PropTypes.number,
    y: PropTypes.number,
    cell: PropTypes.object,
    editable: PropTypes.bool,
    focused: PropTypes.bool,
    setFocus: PropTypes.func
  };

  focusEl = null;

  componentDidUpdate = prevProps => {
    if (this.props.focused && !prevProps.focused) {
      this.focus();
    }
  };

  focus = () => {
    if (this.focusEl) {
      this.focusEl.focus();
    }
  };

  getFillColor = () => {
    const { cell, hint, focused } = this.props;
    const { color } = cell;

    if (focused) {
      return COLOR_FOCUS;
    }

    if (hint) {
      return COLOR_CORRECT;
    }

    if (color !== undefined) {
      return COLORS[color - 1];
    }

    return COLOR_EMPTY;
  };

  render = () => {
    const { x, y, cell, move, focused, setFocus, editable } = this.props;
    const { number } = cell;

    const dx = x * BOX_SIZE;
    const dy = y * BOX_SIZE;

    const label = number !== undefined && (
      <text
        x={dx + (BOX_SIZE - 10)}
        y={dy + (BOX_SIZE - 5)}
        fontFamily="curse_casual, comic sans ms, sans-serif"
        fontSize="10"
        textAnchor="right"
        dominantBaseline="baseline"
        fill={COLOR_TEXT}
      >
        {number}
      </text>
    );

    const focus = editable && (
      <foreignObject x={dx} y={dy} width={BOX_SIZE} height={BOX_SIZE}>
        <Focus focused={focused} move={move} setFocus={setFocus} />
      </foreignObject>
    );

    return (
      <g data-x={x} data-y={y}>
        <CellBackground x={dx} y={dy} color={this.getFillColor()} />
        {label}
        <text
          x={dx + BOX_SIZE / 2}
          y={dy + BOX_SIZE / 2}
          fontFamily="curse_casual, comic sans ms, sans-serif"
          fontSize="40"
          textAnchor="middle"
          dominantBaseline="central"
          fill={COLOR_TEXT}
        >
          {cell.char}
        </text>
        {focus}
      </g>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Cells/Cells/Prefilled/Prefilled.js